function setResult(host, text, isError) {
  if (!(host)) return;
  host.className = isError ? "alert alert-danger mt-2" : "alert alert-info mt-2";
  host.textContent = text || "";
}

module.exports = async function(context) {
  var dashboardApi = (context || {}).dashboardApi || window.DashboardAPI || ((((window.UATools || {}).dashboard || {}).api) || null);
  if (!(dashboardApi)) return;

  var resultHost = document.getElementById("command-result");
  var buttons = document.querySelectorAll("button[data-command-run]");
  if (!(buttons) || buttons.length === 0) return;

  buttons.forEach(function(btn) {
    btn.addEventListener("click", async function() {
      var namespace = (btn.getAttribute("data-command-run") || "").toString().trim();
      if (!(namespace)) return;

      var originalDisabled = btn.disabled;
      var originalHtml = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = "<span class='spinner-border spinner-border-sm me-1' aria-hidden='true'></span>Running";
      setResult(resultHost, "Running " + namespace + "…", false);

      try {
        var response = await dashboardApi.action("platform.commands", "action", {
          action: "run",
          namespace: namespace
        });

        if (!(response && response.success)) {
          var errorItem = (response && response.errors && response.errors[0]) || {};
          setResult(resultHost, errorItem.description || errorItem.title || "Command failed.", true);
          return;
        }

        var payload = response.data || {};
        if (payload.spawned) {
          setResult(resultHost, "Started " + namespace + " in a worker thread. Refreshing status…", false);
        } else {
          setResult(resultHost, "Ran " + namespace + ". Refreshing status…", false);
        }

        setTimeout(function() {
          window.location.reload();
        }, 700);
      } catch (error) {
        console.error("platform.commands run failed", error);
        setResult(resultHost, (error && error.message) || "Command failed.", true);
      } finally {
        btn.disabled = originalDisabled;
        btn.innerHTML = originalHtml;
      }
    });
  });
};
